// src/components/course/CourseHeader.js
import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/variables';
import { useModal } from '../../contexts/ModalContext';

const HeaderSection = styled.section`
  background: ${({ bgImage, bgColor }) =>
    bgImage
      ? `linear-gradient(90deg, rgba(10, 14, 22, 0.86) 0%, rgba(10, 14, 22, 0.68) 42%, rgba(10, 14, 22, 0.28) 100%), url(${bgImage}) center center/cover no-repeat`
      : bgColor || '#007396'};
  color: ${({ textColor }) => textColor || '#fff'};
  padding: 120px 24px 80px;
  margin-top: 64px;
  min-height: 600px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    min-height: 640px;
    padding: 100px 12px 80px;
    background-position: center center;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const HeaderContent = styled.div`
  max-width: 600px;
  
  @media (max-width: 768px) {
    margin-bottom: 48px;
  }
`;

const CourseTag = styled.span`
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.2);
  color: ${({ textColor }) => textColor || '#fff'};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

const CourseTitle = styled.h1`
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 24px;
  color: ${({ textColor }) => textColor || '#fff'};
  text-shadow: ${({ textColor }) => textColor === '#fff' ? '0 2px 18px rgba(0, 0, 0, 0.45)' : 'none'};
  
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

const CourseDescription = styled.p`
  font-size: 18px;
  margin-bottom: 32px;
  color: ${({ textColor }) => textColor || '#fff'};
  text-shadow: ${({ textColor }) => textColor === '#fff' ? '0 2px 14px rgba(0, 0, 0, 0.45)' : 'none'};
`;

const CourseStats = styled.div`
  display: flex;
  margin-bottom: 32px;
`;

const CourseStat = styled.div`
  margin-right: 24px;
  display: flex;
  align-items: center;
`;

const StatIcon = styled.div`
  font-size: 20px;
  margin-right: 8px;
`;

const StatText = styled.div`
  font-weight: 500;
  color: ${({ textColor }) => textColor || '#fff'};
  text-shadow: ${({ textColor }) => textColor === '#fff' ? '0 2px 12px rgba(0, 0, 0, 0.45)' : 'none'};
`;

const HeaderImage = styled.div`
  max-width: 450px;
  
  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
`;

const Button = styled.button`
  display: inline-block;
  background-color: ${colors.secondary};
  color: ${colors.white};
  padding: 12px 24px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 16px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #00a759;
  }
`;

const CourseHeader = ({ 
  tag, 
  title, 
  description, 
  duration, 
  level, 
  bgColor, 
  bgImage, 
  darkText
}) => {
  const { openConsultationModal } = useModal();
  const textColor = darkText ? '#1a1a1a' : '#fff';
  
  return (
    <HeaderSection bgColor={bgColor} bgImage={bgImage} textColor={textColor}>
      <HeaderContainer>
        <HeaderContent>
          <CourseTag textColor={textColor}>{tag}</CourseTag>
          <CourseTitle textColor={textColor}>{title}</CourseTitle>
          <CourseDescription textColor={textColor}>{description}</CourseDescription>
          <CourseStats>
            <CourseStat>
              <StatIcon>⏱️</StatIcon>
              <StatText textColor={textColor}>{duration}</StatText>
            </CourseStat>
            <CourseStat>
              <StatIcon>👨‍💻</StatIcon>
              <StatText textColor={textColor}>{level}</StatText>
            </CourseStat>
          </CourseStats>
          <Button onClick={openConsultationModal}>교육상담 신청하기</Button>
        </HeaderContent>
      </HeaderContainer>
    </HeaderSection>
  );
};

export default CourseHeader;
